import { Injectable } from '@angular/core';

import { CookieService } from 'ngx-cookie';

import { AES, enc } from 'crypto-js';
import jwt_decode from 'jwt-decode';
import { environment } from 'environments/environment';
import { BehaviorSubject } from 'rxjs';
import { debounce } from 'lodash';

@Injectable()
export class SharedService {
  private encrypted: Boolean = environment.encrypted;
  audibleNotificationSettings: BehaviorSubject<any>;
  audio: HTMLAudioElement;
  servicePrompt: any = {
    service: {
      unassign: {
        title: () => 'This service is unassigned',
        message: () => 'This service is not assigned to any technician. To fill out notes, request your admin to assign this service to you.',
        successBtn: () => '',
        cancelBtn: '',
      },
      assignToOther: {
        title: () => 'Service is assigned to another tech',
        message: ({ techName }) => `This service is assigned to tech ${techName}. To fill out this notes, request your admin to assign this service to you`,
        successBtn: () => '',
        cancelBtn: '',
      },
      new: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Start the service?' : 'Clock-In to start the service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn ? `The service ${serviceTitle} needs to be started before you can add / edit Service notes` : 'You are currently clocked out. Clock in to start the service',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Start service' : 'Clock In'),
        cancelBtn: 'Cancel',
      },
      pause: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Start the service?' : 'Clock-In to resume the service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn ? `The service ${serviceTitle} needs to be resumed before you can add / edit Service notes` : 'You are currently clocked out. Clock in to resumed the service',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Resume service' : 'Clock In'),
        cancelBtn: 'Cancel',
      },
      completed: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Restart the service?' : 'Clock-In to restart the service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn
            ? `The service ${serviceTitle} has been completed and needs to be restarted before you can add / edit Service notes`
            : 'You are currently clocked out. Clock in to restart the service',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Restart service' : 'Clock In'),
        cancelBtn: 'Cancel',
      },
      markCompleted: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Complete the service?' : 'Clock-In to complete the service'),
        message: ({ serviceTitle, isClockedIn }) => (isClockedIn ? `` : 'You are currently clocked out. Clock in to complete the service'),
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Complete service' : 'Clock In'),
        cancelBtn: 'Cancel',
      },
      pauseService: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Pause the service?' : 'Clock-In to pause the service'),
        message: ({ serviceTitle, isClockedIn }) => (isClockedIn ? `` : 'You are currently clocked out. Clock in to pause the service'),
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Pause service' : 'Clock In'),
        cancelBtn: 'Cancel',
      },
    },
    inspection: {
      unassign: {
        title: () => 'This service is unassigned',
        message: () => 'This service is not assigned to any technician. To fill out this inspection, request your admin to assign this service to you.',
        successBtn: () => '',
        cancelBtn: '',
      },
      restriction: {
        title: () => 'This section is available to only view',
        message: () => 'Kindly contact the primary technician on this service to edit the details.',
        successBtn: () => '',
        cancelBtn: '',
      },
      assignToOther: {
        title: () => 'Service is assigned to another tech',
        message: ({ techName }) => `This service is assigned to tech ${techName}. To fill out this inspection, request your admin to assign this service to you`,
        successBtn: () => '',
        cancelBtn: '',
      },
      new: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Start the service?' : 'Clock-In to start the service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn ? `The service ${serviceTitle} needs to be started before you can fill out the inspection` : 'You are currently clocked out. Clock in to start the service',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Start service' : 'Clock In'),
        cancelBtn: 'Cancel',
      },
      pause: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Start the service?' : 'Clock-In to resume the service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn ? `The service ${serviceTitle} needs to be resumed before you can fill out the inspection` : 'You are currently clocked out. Clock in to resume the service',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Resume service' : 'Clock In'),
        cancelBtn: 'Cancel',
      },
      completed: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Restart the service?' : 'Clock-In to restart the service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn
            ? `The service ${serviceTitle} has been completed and needs to be restarted before you can fill out the inspection`
            : 'You are currently clocked out. Clock in to restart the service',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Restart service' : 'Clock In'),
        cancelBtn: 'Cancel',
      },
    },
  };
  servicePromptFR: any = {
    service: {
      unassign: {
        title: () => 'Ce service n\'est pas attribué',
        message: () => 'Ce service n\'est attribué à aucun technicien. Pour remplir les notes, demandez à votre administrateur de vous attribuer ce service.',
        successBtn: () => '',
        cancelBtn: '',
      },
      assignToOther: {
        title: () => 'Le service est attribué à un autre technicien',
        message: ({ techName }) => `Ce service est attribué au technicien ${techName}. Pour remplir ces notes, demandez à votre administrateur de vous attribuer ce service.`,
        successBtn: () => '',
        cancelBtn: '',
      },
      new: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Commencer le service?' : 'Connectez-vous pour commencer le service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn ? `Le service ${serviceTitle} doit être commencé avant que vous puissiez ajouter/modifier les notes de service.` : 'Vous êtes actuellement déconnecté. Connectez-vous pour commencer le service.',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Commencer le service' : 'Se connecter'),
        cancelBtn: 'Annuler',
      },
      pause: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Reprendre le service?' : 'Connectez-vous pour reprendre le service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn ? `Le service ${serviceTitle} doit être repris avant que vous puissiez ajouter/modifier les notes de service.` : 'Vous êtes actuellement déconnecté. Connectez-vous pour reprendre le service.',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Reprendre le service' : 'Se connecter'),
        cancelBtn: 'Annuler',
      },
      completed: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Redémarrer le service?' : 'Connectez-vous pour redémarrer le service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn
            ? `Le service ${serviceTitle} a été complété et doit être redémarré avant que vous puissiez ajouter/modifier les notes de service.`
            : 'Vous êtes actuellement déconnecté. Connectez-vous pour redémarrer le service.',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Redémarrer le service' : 'Se connecter'),
        cancelBtn: 'Annuler',
      },
      markCompleted: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Terminer le service?' : 'Connectez-vous pour terminer le service'),
        message: ({ serviceTitle, isClockedIn }) => (isClockedIn ? `` : 'Vous êtes actuellement déconnecté. Connectez-vous pour terminer le service.'),
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Terminer le service' : 'Se connecter'),
        cancelBtn: 'Annuler',
      },
      pauseService: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Mettre en pause le service?' : 'Connectez-vous pour mettre en pause le service'),
        message: ({ serviceTitle, isClockedIn }) => (isClockedIn ? `` : 'Vous êtes actuellement déconnecté. Connectez-vous pour mettre en pause le service.'),
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Mettre en pause le service' : 'Se connecter'),
        cancelBtn: 'Annuler',
      },
    },
    inspection: {
      unassign: {
        title: () => 'Ce service n\'est pas attribué',
        message: () => 'Ce service n\'est attribué à aucun technicien. Pour remplir cette inspection, demandez à votre administrateur de vous attribuer ce service.',
        successBtn: () => '',
        cancelBtn: '',
      },
      restriction: {
        title: () => 'Cette section est disponible uniquement en lecture',
        message: () => 'Veuillez contacter le technicien principal de ce service pour modifier les détails.',
        successBtn: () => '',
        cancelBtn: '',
      },
      assignToOther: {
        title: () => 'Le service est attribué à un autre technicien',
        message: ({ techName }) => `Ce service est attribué au technicien ${techName}. Pour remplir cette inspection, demandez à votre administrateur de vous attribuer ce service.`,
        successBtn: () => '',
        cancelBtn: '',
      },
      new: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Commencer le service?' : 'Connectez-vous pour commencer le service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn ? `Le service ${serviceTitle} doit être commencé avant que vous puissiez remplir l'inspection.` : 'Vous êtes actuellement déconnecté. Connectez-vous pour commencer le service.',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Commencer le service' : 'Se connecter'),
        cancelBtn: 'Annuler',
      },
      pause: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Reprendre le service?' : 'Connectez-vous pour reprendre le service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn ? `Le service ${serviceTitle} doit être repris avant que vous puissiez remplir l'inspection.` : 'Vous êtes actuellement déconnecté. Connectez-vous pour reprendre le service.',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Reprendre le service' : 'Se connecter'),
        cancelBtn: 'Annuler',
      },
      completed: {
        title: ({ isClockedIn }) => (isClockedIn ? 'Redémarrer le service?' : 'Connectez-vous pour redémarrer le service'),
        message: ({ serviceTitle, isClockedIn }) =>
          isClockedIn
            ? `Le service ${serviceTitle} a été complété et doit être redémarré avant que vous puissiez remplir l'inspection.`
            : 'Vous êtes actuellement déconnecté. Connectez-vous pour redémarrer le service.',
        successBtn: ({ isClockedIn }) => (isClockedIn ? 'Redémarrer le service' : 'Se connecter'),
        cancelBtn: 'Annuler',
      },
    },
  };

  constructor(private cookieService: CookieService) {
    this.audibleNotificationSettings = new BehaviorSubject({});
  }

  decryptData = (data: any) => {
    if (this.encrypted) {
      const bytes = AES.decrypt(data.d.toString(), enc.Utf8.parse(environment.adatak), { iv: enc.Utf8.parse(environment.bdatak) });
      const decryptedData = JSON.parse(bytes.toString(enc.Utf8));
      return decryptedData;
    } else {
      return data;
    }
  };

  jwtDecode(token: any) {
    if (token) return jwt_decode(token);
  }

  getCompany() {
    const alpat = this.cookieService.getObject('alpat');

    if (!alpat) return {};

    const token: any = this.jwtDecode(alpat);
    let shopId = token.shopId;
    const currentShopId = localStorage.getItem('currentShop');
    if (token.isMultiLocationEnabled && currentShopId) shopId = currentShopId;
    if (token) {
      return {
        companyId: token.companyId,
        companyType: token.companyType,
        companyEmail: token.email,
        shopId,
        companyName: token.name,
        companyPhone: token.phone,
        logo: token.logo,
        userName: token.fullName,
        isSupportUser: token.isSupportUser,
        role: token.role,
        stateCode: token.stateCode,
        userId: token.id,
        emplyeeId: token.employeeId,
        employeeId: token.employeeId,
        timezone: token.timezone,
        qboId: token.qboId,
        corporateId: token.corporateId,
        qbo: token.QBO,
        iat: token.iat,
        isDTS: token.isDTS,
        isWorkAsTechEnabled: token.isWorkAsTechEnabled,
        hasMultiLocationAccess: token.hasMultiLocationAccess,
        isMultiLocationEnabled: token.isMultiLocationEnabled,
        isRevenueRecognitionSettleEnabled: token.isRevenueRecognitionSettleEnabled,
        isShopTzUseEnabled: token.isShopTzUseEnabled,
      };
    } else {
      return {};
    }
  }

  setNotificationSound(event, notificationSettings) {
    const soundType = notificationSettings[event];
    const audio = soundType === 'light' ? '../../assets/audio/light.mp3' : soundType === 'medium' ? '../../assets/audio/medium.mp3' : soundType === 'urgent' ? '../../assets/audio/urgent.mp3' : '';

    if (audio) this.playNotification(audio);
  }

  playNotification(audioSound) {
    this.audio = new Audio();
    this.audio.src = audioSound;
    this.audio.muted = false;
    this.audio.load();
    this.audio.play();
  }

  setNotificationSoundForTech(event: any, notificationSettings: any) {
    const soundType = notificationSettings && notificationSettings[event];
    const audioMap = {
      light: '../../assets/audio/light.mp3',
      medium: '../../assets/audio/medium.mp3',
      urgent: '../../assets/audio/urgent.mp3',
    };
    const audio = audioMap[soundType];
    const element = document.getElementById(`audio-${soundType}`);

    if (audio) {
      this.playNotificationForTech(audio);
    }
  }

  playNotificationForTech = debounce((audioSound: string) => {
    try {
      if (this.isAppleDevice()) {
        if (!this.audio) {
          return;
        }
      }
      this.audio = new Audio();
      this.audio.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
      this.audio.src = audioSound;

      this.audio.muted = false;
      this.audio.load();
      this.audio.play();
      console.log('success in paly audio');
    } catch (err) {
      console.log('error in paly audio', err);
    }
  }, 2000);

  isAppleDevice() {
    try {
      return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform);
    } catch (err) {
      console.log(err);
      return false;
    }
  }
}
